export default __webpack_public_path__ + "static/step1-4f8f2aa856dc74b1772e3a5c0397c728.webp";